(() => {
  if (window.__talebloomCartChoiceInitialized) return;
  window.__talebloomCartChoiceInitialized = true;

  const styles = `
    .talebloom-cart-choice-backdrop{position:fixed;inset:0;z-index:99999;background:rgba(39,26,20,.58);display:flex;align-items:center;justify-content:center;padding:20px}
    .talebloom-cart-choice{position:relative;width:min(100%,430px);background:#fffaf5;color:#39271f;border-radius:16px;padding:30px 24px 24px;box-shadow:0 18px 60px rgba(0,0,0,.24);text-align:center;font-family:inherit}
    .talebloom-cart-choice__close{position:absolute;right:12px;top:10px;border:0;background:transparent;color:#39271f;font-size:28px;line-height:1;padding:8px;cursor:pointer}
    .talebloom-cart-choice__eyebrow{font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#793d27;margin:0 0 10px}
    .talebloom-cart-choice h2{font-size:clamp(24px,6vw,30px);line-height:1.2;margin:0 0 10px;color:#39271f}
    .talebloom-cart-choice p{font-size:15px;line-height:1.5;margin:0 0 22px}
    .talebloom-cart-choice__actions{display:grid;gap:10px}
    .talebloom-cart-choice__button{display:flex;align-items:center;justify-content:center;min-height:52px;padding:13px 18px;border-radius:8px;font:inherit;font-weight:600;text-decoration:none;cursor:pointer}
    .talebloom-cart-choice__checkout{background:#793d27;color:#fff;border:1px solid #793d27}
    .talebloom-cart-choice__continue{background:transparent;color:#793d27;border:1px solid #793d27}
    @media(min-width:480px){.talebloom-cart-choice{padding:34px 30px 28px}}
  `;

  function closeModal() {
    const backdrop = document.querySelector('.talebloom-cart-choice-backdrop');
    if (!backdrop) return;
    backdrop.remove();
    document.body.style.overflow = '';
  }

  function openModal() {
    closeModal();
    if (!document.getElementById('talebloom-cart-choice-styles')) {
      const style = document.createElement('style');
      style.id = 'talebloom-cart-choice-styles';
      style.textContent = styles;
      document.head.appendChild(style);
    }
    const backdrop = document.createElement('div');
    backdrop.className = 'talebloom-cart-choice-backdrop';
    backdrop.innerHTML = `
      <section class="talebloom-cart-choice" role="dialog" aria-modal="true" aria-labelledby="talebloom-cart-choice-title" aria-describedby="talebloom-cart-choice-description">
        <button class="talebloom-cart-choice__close" type="button" aria-label="Fenster schließen">&times;</button>
        <p class="talebloom-cart-choice__eyebrow">Erfolgreich hinzugefügt</p>
        <h2 id="talebloom-cart-choice-title">Wie möchtest du weitermachen?</h2>
        <p id="talebloom-cart-choice-description">Dein Buch liegt im Warenkorb.</p>
        <div class="talebloom-cart-choice__actions">
          <a class="talebloom-cart-choice__button talebloom-cart-choice__checkout" href="${window.Shopify?.routes?.root || '/'}checkout">Zur Kassa</a>
          <button class="talebloom-cart-choice__button talebloom-cart-choice__continue" type="button">Weiter einkaufen</button>
        </div>
      </section>`;
    backdrop.addEventListener('click', (event) => {
      if (event.target === backdrop || event.target.closest('.talebloom-cart-choice__close') || event.target.closest('.talebloom-cart-choice__continue')) {
        closeModal();
      }
    });
    document.body.appendChild(backdrop);
    document.body.style.overflow = 'hidden';
    backdrop.querySelector('.talebloom-cart-choice__close')?.focus();
    document.addEventListener('keydown', function onEscape(event) {
      if (event.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', onEscape);
      }
    }, { once: true });
  }

  document.addEventListener('talebloom:cart-added', openModal);
})();